import LogRocket from 'logrocket';
import { StripeTerminalConnectError } from '../../store/StripeTerminal/StripeTerminalConnectError';
import { selectors } from '../../store/StripeTerminal/StripeTerminal.selectors';

type WaitForReaderConnectionOptions = {
  getState: () => any,
  pollInterval?: number,
  timeout?: number,
};
/** Allows application logic to await on a connection to complete; includes
     * timeout logic to gracefully fail if the model is stuck in the connecting state */
export const waitForReaderConnection = async (
  {
    getState, pollInterval = 500, timeout = 10000,
  }: WaitForReaderConnectionOptions,
): Promise<boolean> => {
  if (selectors.isConnected(getState())) {
    return true;
  }
  if (selectors.isNotConnected(getState())) {
    throw new StripeTerminalConnectError('Reader Not Connected');
  }

  let pollingId: ReturnType<typeof setInterval>;
  let timeoutId: ReturnType<typeof setTimeout>;
  return new Promise((resolve, reject) => {
    pollingId = setInterval(() => {
      if (selectors.isConnected(getState())) {
        if (timeoutId) clearTimeout(timeoutId);
        resolve(true);
        clearInterval(pollingId);
      }
    }, pollInterval);

    timeoutId = setTimeout(() => {
      if (pollingId) clearInterval(pollingId);
      if (selectors.isConnected(getState() as any)) {
        resolve(true);
      } else {
        LogRocket.track('Tap to Pay Checkout Reader Connection Timed Out');
        reject(new StripeTerminalConnectError('Connection timed out'));
      }
    }, timeout);
  });
};
